export const mockNames = [
    "Anum Reeve",
    "Tiernan Stubbs",
    "Hakim Hernandez",
    "Madihah Maynard",
    "Mac Beard",
    "Gracie-Mae Dunne",
    "Oliver Leigh",
    "Jose Tapia",
    "Lyle Beasley",
    "Arslan Samuels",
    "Dolores Viale",
    "Romola De Carlo",
    "Nilde Mancino",
    "Donata Curro",
    "Beatrice Pata",
    "Ella Notaro",
    "Acilia Simoni",
    "Berenice Rutigliano",
    "Ilia Gangi",
    "Atanasia Bonacci",
    "Jyoti Sane",
    "Shaili Potrick",
    "Manjusha Dehadray",
    "Meera Deoghar",
    "Sameera Bhole",
    "Bimla Jichkar",
    "Kavita Phadake",
    "Unnati Zantye",
    "Chandra Govatrikar",
    "Gauravi Kotwal",
    "Keenan Robinson",
    "Destin Ellis",
    "Tremon Epps",
    "Quinell Palmer",
    "Demarien Murphy",
    "Andres Coleman",
    "Reginal Charles",
    "Terryl Young",
    "Herold Mitchell",
    "Kione Butler",
    "Magdalena Czech",
    "Wioleta Pach",
    "Zofia Stasiak",
    "Cecylia Wydra",
    "Balbina Ochocka",
    "Kinga Piłat",
    "Kalina Krzemien",
    "Olga Moszkowicz",
    "Maryla Jeżewska",
    "Odeta Turek",
    "Noud Groothalle",
    "Teun Ekkerink",
    "Pier Assendorp",
    "Matthijs Mennink",
    "Korneel Septer",
    "Andries IJsak",
    "Freek Vellener",
    "Koen Lokman",
    "Lodewijk Struijck",
    "Stefaan Houtzagers",
    "Buddy Saunders",
    "Dennis Hunter",
    "Alfie Moss",
    "River Lewis",
    "Tomas Stone",
    "Samuel Kelly",
    "Rory Phillips",
    "Thomas Hussain",
    "Ralphy Palmer",
    "Eric Evans",
    "Silver Gardner",
    "Jody Wright",
    "Dane Mills",
    "Sam Mason",
    "Rudy Powell",
    "Carol Griffith",
    "Brynn Witt",
    "Jaden Terrell",
    "Riley Rice",
    "Ash Mcintosh",
    "Rowan Edwards",
    "Ryan Shaw",
    "Riley Harris",
    "Danni Francis",
    "Will Lloyd",
    "Danni Roy",
    "Alex Dean",
    "Bev Gamble",
    "Danny Blair",
    "Leslie Diaz",
    "Sugondo Xiaohui",
    "Ateng Nuwa",
    "Ymkje Anakotta",
    "Merry Situmorang",
    "Jochebed Selangit",
    "Ruby Silo",
    "Raja Nizar",
    "Fida Nicola",
    "Fairuz Jasir",
    "Tarub Jamal",
    "Zainab Sabri",
    "Rima Khalid",
    "Najla Karam",
    "Oleksandra Andriyenko",
    "Sofiya Hlushko",
    "Myroslava Kornijchuk",
    "Alina Tymchenko",
    "Lina Kravchuk",
    "Zhanna Novikova",
    "Natalya Kravets",
    "Nadiya Movchan",
    "Nina Sayenko",
    "Hanna Tretyak",
    "Artim Washere",
  ];
  
  export const getMemberName = () =>
    mockNames[Math.floor(Math.random() * mockNames.length)];
  